<template>
    <div class="error">
        <div class="container-floud">
            <div class="col-xs-12 ground-color text-center">
                <div class="container-error-404">
                    <div class="clip">
                        <div class="shadow">
                            <span class="digit thirdDigit">4</span>
                        </div>
                    </div>
                    <div class="clip">
                        <div class="shadow">
                            <span class="digit secondDigit">0</span>
                        </div>
                    </div>
                    <div class="clip">
                        <div class="shadow">
                            <span class="digit firstDigit">4</span>
                        </div>
                    </div>
                    <div class="msg">OH!
                        <span class="triangle"></span>
                    </div>
                </div>
                <h2 class="h1">很抱歉，你访问的页面找不到了</h2>
                <h2 class="h1 h2">This page no longer exists</h2>
                <div class="right">
                    <a href="/index.aspx">返回首页</a>
                    <a href="javascript:history.back(-1);">返回上一页</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: '404错误',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html {
    font-size: 10px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
}
body {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
    background-color: #fff
}

* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box
}

:after,
:before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box
}

.col-xs-12 {
    width: 100%;
    float: left;
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
}

.text-center {
    text-align: center;
}
.error .clip .shadow {
    height: 180px;
}

.error .clip:nth-of-type(2) .shadow {
    width: 130px;
}

.error .clip:nth-of-type(1) .shadow,
.error .clip:nth-of-type(3) .shadow {
    width: 250px;
}

.error .digit {
    width: 150px;
    height: 150px;
    line-height: 150px;
    font-size: 120px;
    font-weight: bold;
}

.error h2 {
    font-size: 32px;
}

.error .msg {
    top: -190px;
    left: 30%;
    width: 80px;
    height: 80px;
    line-height: 80px;
    font-size: 32px;
}

.error span.triangle {
    top: 70%;
    right: 0%;
    border-left: 20px solid #535353;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
}

.error .container-error-404 {
    margin-top: 10%;
    position: relative;
    height: 250px;
    padding-top: 40px;
}

.error .container-error-404 .clip {
    display: inline-block;
    transform: skew(-45deg);
}

.error .clip .shadow {
    overflow: hidden;
}

.error .clip:nth-of-type(2) .shadow {
    overflow: hidden;
    position: relative;
    box-shadow: inset 20px 0px 20px -15px rgba(150, 150, 150, 0.8), 20px 0px 20px -15px rgba(150, 150, 150, 0.8);
}

.error .clip:nth-of-type(3) .shadow:after,
.error .clip:nth-of-type(1) .shadow:after {
    content: "";
    position: absolute;
    right: -8px;
    bottom: 0px;
    z-index: 9999;
    height: 100%;
    width: 10px;
    background: linear-gradient(90deg, transparent, rgba(173, 173, 173, 0.8), transparent);
    border-radius: 50%;
}

.error .clip:nth-of-type(3) .shadow:after {
    left: -8px;
}

.error .digit {
    position: relative;
    top: 8%;
    color: white;
    background: #07F993;
    border-radius: 50%;
    display: inline-block;
    transform: skew(45deg);
}

.error .clip:nth-of-type(2) .digit {
    left: -10%;
}

.error .clip:nth-of-type(1) .digit {
    right: -20%;
}

.error .clip:nth-of-type(3) .digit {
    left: -20%;
}

.error h2 {
    font-size: 24px;
    color: #A2A2A2;
    font-weight: bold;
    padding-bottom: 5px;
    border-bottom: 2px solid #A2A2A2;
    width: 340px;
    margin: 0 auto;
}

.error h2.h2 {
    padding-top: 5px;
    padding-bottom: 20px;
    border-bottom: 0px solid #fff;
}

.error .msg {
    position: relative;
    z-index: 9999;
    display: block;
    background: #535353;
    color: #A2A2A2;
    border-radius: 50%;
    font-style: italic;
}

.error .triangle {
    position: absolute;
    z-index: 999;
    transform: rotate(45deg);
    content: "";
    width: 0;
    height: 0;
}

.right a {
    display: inline-block;
    font-size: 16px;
    line-height: 36px;
    height: 36px;
    border: 1px solid #07F993;
    padding: 0 25px;
    border-radius: 20px;
    margin: 0 10px;
    text-decoration: none;
    transition: ease-in 0.5s;
    -moz-transition: ease-in 0.5s;
    /* Firefox 4 */
    -webkit-transition: ease-in 0.5s;
    /* Safari and Chrome */
    -o-transition: ease-in 0.5s;
    /* Opera */
}

a:link {
    color: #07F993;
}

.right a:hover {
    background: #07F993;
    color: #fff;
}

@media(max-width: 767px) {
    .error .clip .shadow {
        height: 100px;
    }
    .error .clip:nth-of-type(2) .shadow {
        width: 80px;
    }
    .error .clip:nth-of-type(1) .shadow,
    .error .clip:nth-of-type(3) .shadow {
        width: 100px;
    }
    .error .digit {
        width: 80px;
        height: 80px;
        line-height: 80px;
        font-size: 52px;
    }
    .error h2 {
        font-size: 18px;
    }
    .error .msg {
        top: -110px;
        left: 15%;
        width: 40px;
        height: 40px;
        line-height: 40px;
        font-size: 18px;
    }
    .error span.triangle {
        top: 70%;
        right: -3%;
        border-left: 10px solid #07F993;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
    }
    .error .container-error-404 {
        height: 150px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue